<template>
    <section class="documentation">
        <section>
            <div class="form-custom d-flex align-items-end flex-wrap mb-5 mb-xl-7">
                <fieldset>
                    <label for="select-resource-type">Degré d'enseignement</label>
                    <div class="container-select">
                        <select id="select-resource-type" v-model="form.filterResourceTypesId">
                            <option v-for="(item, index) in filtersResourceTypes" :key="index" :value="item.id">{{item.label}}</option>
                        </select>
                    </div>
                </fieldset>
                <fieldset>
                    <label for="select-domain">Domaine</label>
                    <div class="container-select">
                         <select id="select-domain" v-model="form.filterDomainsId">
                            <option v-for="(item, index) in filtersDomains" :key="index" :value="item.id">{{item.label}}</option>
                        </select>
                    </div>
                </fieldset>
                <button v-on:click="search()" class="btn outline button">chercher</button>
            </div>
        </section>

        <hr class="section-sep">

        <div class="loader-wrap" v-if="loading">
            <div class="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>

        <transition-group
            tag="div"
            class="vue-bloc-ressources"
            v-on:before-enter="beforeEnter"
            v-on:enter="enter">

            <section class="wrap-bloc" v-for="(taxoItem,index) in result" :key="index+1">
                <header class="wrap-bloc__header">
                    <h2 class="wrap-bloc__title" v-html="taxoItem.name"></h2>
                    <p class="wrap-bloc__txt" v-html="taxoItem.description"></p>
                </header>

                <div class="d-flex flex-wrap justify-content-center justify-content-xl-start">
                    <article class="bloc-card bloc-card--ressources" v-for="(item, indexItem) in taxoItem.posts" :key="index+':'+indexItem">
                        <div class="bloc-card__img">
                            <img :src="item.thumbnail" alt="">
                            <div class="bloc-card__taxos">
                                <span v-if="item.domain">{{item.domain}}</span>
                                <span v-if="item.category">{{item.category}}</span>
                            </div>
                        </div>
                        
                        <div class="bloc-card__body">
                            <h3 class="bloc-card__title">
                                <a :href="item.url" v-html="item.title"></a>
                            </h3>
                            <p class="bloc-card__text" v-html="item.summary_html"></p>
                            <a :href="item.url" class="bloc-card__link">
                                en savoir +
                            </a>
                        </div>
                    </article>
                </div>
            </section>
        </transition-group>
    </section>
</template>

<script>
    import $ from "jquery";
    import Ajax from "../../mixins/ajax"
    import Animation from "../../mixins/animation"
    import Scrolling from "../../libs/Scrolling"

    export default {
        mixins: [Ajax, Animation],
        props: {
            filtersResourceTypes: {
                type: Array,
                required: true,
            },
            filtersDomains: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                result: null,
                loading: false,
                pagination: {},
                firstLoad: true,
                form: {
                    filterResourceTypesId: "",
                    filterDomainsId: "",
                },
                showLinksWrap: false,
            };
        },
        computed: {
            breakpointDownMd() {
                return this.$root.breakpointDownMd;
            },
        },
        methods: {
            formSubmit(form) {
                this.loading = true;
                this.result = null;
                if (form) {
                    this.form = form;
                }
                /*                if (!this.form.page) {
                                    this.form.page = 1;
                                }*/

                if (!this.firstLoad) {
                    Scrolling.scrollTo(".vue-bloc-ressources", "easeOutCubic", 600, 200);

                }

                this.ajax("ressources", "getRessources", {form: this.form}).always((data) => {
                    if (typeof data.result !== "undefined") {
                        this.loading = false;
                        this.result = data.result;
                        this.firstLoad = false

                    } else {
                        console.log("error");
                    }
                });


            },
            search() {
                this.formSubmit()
            },
            getResume(item) {
                let link = "<a href=\"" + item.url + "\" class=\"more\">— Voir</a>";
                return item.summary_html + " " + link
            },
            openItem(item) {
                if (this.breakpointDownMd) {
                    window.location = item.url
                }
            }
        },
        created() {
            this.animDelta = 100
        },
        mounted() {
            this.formSubmit()
        },
        destroyed() {
        }
    };
</script>
